<div class="stage">
  <div class="glow"></div>
  <div class="card">
    <div class="liquid"></div>
    <span class="mark"></span>
  </div>
</div>
